module.exports = __webpack_public_path__ + "img/PPT.b9532431.png";